import { render, staticRenderFns } from "./iconImg.vue?vue&type=template&id=124614d4&scoped=true&"
import script from "./iconImg.vue?vue&type=script&lang=js&"
export * from "./iconImg.vue?vue&type=script&lang=js&"
import style0 from "./iconImg.vue?vue&type=style&index=0&id=124614d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124614d4",
  null
  
)

export default component.exports